
<div id="nonexistentJobsModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
  <div style="background-color: #ffffff;
  margin: 25% auto;
  padding: 2em;
  border: 1px solid #888;
  width: 80%;
  max-width: 300px;
  border-radius: 1em;">
    <p style="color: #424242;font-weight: 600;">Jobs not found: </p>

    <div *ngFor="let obj of nonexisting_jobs">
     <p>{{obj}}</p>
    </div>

    <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="closeNonExistingModal()">OK</button>
  </div>
</div>



<div id="gasModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">

  <div style="background-color: #ffffff;
  margin: 25% auto;
  padding: 2em;
  border: 1px solid #888;
  width: 80%;
  max-width: 300px;
  border-radius: 1em;">
    <p style="color: #424242;font-weight: 600;">Enter the name of the gas utility:</p>
    <input id="gasInput" style="margin-bottom: 2em;"/>
    <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleGasResponse(true)">Save</button>
    <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleGasResponse(false)">Cancel</button>
  </div>
</div>

<div id="elecModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
  <div style="background-color: #ffffff;
  margin: 25% auto;
  padding: 2em;
  border: 1px solid #888;
  width: 80%;
  max-width: 300px;
  border-radius: 1em;">
    <p style="color: #424242;font-weight: 600;">Enter the name of the electric utility:</p>
    <input id="elecInput" style="margin-bottom: 2em;" />
    <button style="border: 0;margin-right: 2em;background: #8cc63f;color: white;width: 4em;" (click)="handleElecResponse(true)">Save</button>
    <button style="background: #ffffff;color: #424242;width: 4em;border: 1px solid #d8d8d8;" (click)="handleElecResponse(false)">Cancel</button>
  </div>
</div>

<div id="swpppmodal" style="display:none; position:fixed; z-index:1000; left:0; top:0;
 width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">

  <div style="background-color: #ffffff;
    margin: 30% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 500px;
    border-radius: 1em;
    height: 400px;">
    
      <div style="padding-bottom: 2em;
          background-color: white;
          font-size: 1.2em;
          color: #424242;">
        
        <p style="font-weight: 600;">Select a schedule</p>

        <div>
          <select name="swpppsched" id="swpppsched" style="padding: 0.5em;
              padding-right: 1em;
              color: #424242;
              border: #d3d3d3 1px solid;
              background: white;">
            <option value="">(Select a Value)</option> 
            <option value="Monday/Thursday">Monday/Thursday</option>
            <option value="Tuesday/Friday">Tuesday/Friday</option>
          </select>
        </div>
      </div>

        <label for="swpppDateInput" style="color: #424242;font-weight: 600;">
          Enter the SWPPP start date:</label><br>
        <input name="swppp_date" type="date" id="swpppDateInput" style="padding: 0.5em;
          margin-bottom: 2em;
          padding-right: 4em;
          border: 1px solid #d3d3d3;margin-bottom: 2em;"/>

        <div style="display: flex;;
          justify-content: space-around;">
          <button style="border: 0;
            height: 3em;
            width: 12em;
            background: #8cc63f;
            border-radius: 0.5em;
            color: white;" (click)="handleSWPPPResponse(false)"> Confirm </button>
          <button style="border: 0;
            height: 3em;
            width: 12em;
            background: #ffffff;
            border-radius: 0.5em;
            color: rgb(0, 0, 0);" (click)="handleSWPPPResponse(true)"> Cancel </button>
        </div>
  </div>

</div>




<form  [formGroup] = "locationForm">

  <div class="menuParent">
    <h1 class="menuChild" mat-dialog-title>
      <ng-container *ngIf="mode == EDITING_MODE; else addLocation">{{ 'Editing ' + data.street_address }}</ng-container>
      <ng-template #addLocation>Add Location</ng-template>
      <button mat-button color="green" (click)="goToTags()" style="display: inline-block; margin-left: 20px;">
        <fa-icon tooltip [icon]="fatags"></fa-icon>
      </button>
      <button mat-button type="button" color="green" (click)="addUtilityDialog()" style="display: inline-block;">Add Utility</button>
    </h1>
  </div>

  <mat-tab-group #myTabGroup>
  <mat-tab label = "Basic" dynamicHeight = false>

  <div fxLayout.xs="column" class="divContent" style="height:550px !important;">
  <br>

    <mat-form-field style="width:80%">
      <mat-label>Track:</mat-label>
      <mat-select formControlName = "track" (selectionChange)="trackDirty($event.value)">
        <mat-option *ngFor="let track of tracks" [value]="track.id">{{track.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <p *ngIf = "locationForm.get('track').value > 0 && trackCustomerId() === 0" style="padding-bottom: 1em;
      font-weight: bold;
      color: red;
      font-size: 12px;
      letter-spacing: 1px;">Note: This location has no builder assigned, so jobs will not be created for track.</p>


      <mat-form-field style="width: 80%; line-height: 1em;">
        <mat-label>Compliance Track:</mat-label>
        <mat-select style="font-size: 20px;" formControlName="comptrack" (selectionChange)="complianceTrackDirty()">
          <mat-option *ngFor="let track of complianceTracks" [value]="track.id" [ngStyle]="{'font-size': '16px'}">
            <span><p style="font-size:16px !important;">{{ track.name }}</p></span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <p *ngIf = "locationForm.get('comptrack').value > 0 && (locationForm.get('customer_id').value === 0 || locationForm.get('customer_id').value === null)" style="padding-bottom: 1em;
      font-weight: bold;
      color: red;
      font-size: 12px;
      letter-spacing: 1px;">Note: This location has no builder assigned, so jobs will not be created for track.</p>



    <mat-form-field style="width:80%">
        <mat-label>Street Address:</mat-label>
        <input matInput formControlName = "street_address" (blur)="checkForDuplicateSA()">
      </mat-form-field>

      <div *ngIf = 'showtext.length > 0'>
        <span *ngIf="isDuplicate"><p style="color:red;">{{showtext}}</p></span>
        <span *ngIf="!isDuplicate"><p style="color: #7c7c7c;">{{showtext}}</p></span>
       </div>
       <div *ngIf="similarLocations.length" style="margin: 2px 0 6px 0;">
         <p *ngFor="let loc of similarLocations" style="color:#b26a00; margin:0; font-size:0.9em;">
           {{ loc.street_address }} — {{ loc.subdivision_name }}<span *ngIf="loc.lot">, lot {{ loc.lot }}</span> (id {{ loc.location_id }})
         </p>
       </div>



      <mat-form-field style="width:80%">
          <mat-label>Subdivision: {{subdivisionDisplay}}</mat-label>
          <input type="text"  #subname matInput formControlName= "subdivision_name" [matAutocomplete] = "subdivisionAuto" autocomplete="off" (blur)="onSubdivisionBlur()">

      <mat-autocomplete #subdivisionAuto = "matAutocomplete" (optionSelected) = "onSelectSubdivision($event.option.value)" [displayWith]="displayFunction">
          <mat-option *ngFor="let subdivision of (subdivision$ | async)" [value]="subdivision">
            <span>{{ subdivision.subdivision_name}}</span>
            <span *ngIf="subdivision.scope" style="color:#888; font-size:0.85em; margin-left:4px;">({{ subdivision.scope }})</span>
          </mat-option>
        </mat-autocomplete>

        <button style="background: #424242;
        color: white;
        border-color: white;" (click)="clearSubdivision()">X</button>
      </mat-form-field>
      <p *ngIf="subdivisionError" style="color:red; margin:0 0 6px 0; font-size:0.9em;">{{subdivisionError}}</p>
      <p *ngIf="!subdivisionError && subdivisionIsLegacyPristine && locationForm.get('subdivision').value < 1 && locationForm.get('subdivision_name').value"
         style="color:#b26a00; margin:0 0 6px 0; font-size:0.9em;">
        This location's subdivision is not linked to a subdivision record. Please pick one from the list.
      </p>
      <p style="font-weight: bold;
      color: #424242;
      font-size: 12px;
      letter-spacing: 1px;">Builder: {{buildertext}} <span style="color:red;"> {{paymenthold ? ' (Payment Hold)' : ''}} </span>


      <button *ngIf="buildertext.includes('(No Builder)')"  (click)="addBuilderClick()" class="builderButton"> + Add Builder</button>

      <button *ngIf="!buildertext.includes('(No Builder)')" (click)="addBuilderClick()" class="builderButton">- Change Builder</button>
          
    
    
    </p> 
    <div *ngIf="paymenthold && (locationForm.get('comptrack').value > 0 || locationForm.get('track').value > 0 )"> <p style="color: red;"> *Note: track jobs will not be created due to the payment hold.</p></div>
      
      


        <mat-form-field style="width:80%">
          <mat-label>Lot:</mat-label>
          <input matInput formControlName = "lot" (blur)="checkForDuplicateSubLot()">
        </mat-form-field>

      <div *ngIf = 'subtext.length > 0'>
        <span *ngIf="subisDuplicate"><p style="color:red;">{{subtext}}</p></span>
        <span *ngIf="!subisDuplicate"><p style="color: #7c7c7c;">{{subtext}}</p></span>
       </div>

        <mat-form-field style="width:80%">
      <div matRipple [matRippleDisabled]="true" #subRipple style="display:flex;">
          <mat-label style="margin-right: 5px;">City:</mat-label>
          <input  #cityname matInput formControlName = "city" [matAutocomplete]="cityAuto">


          <mat-autocomplete #cityAuto = "matAutocomplete" (optionSelected) = "onSelectCity($event.option.value)">
            <mat-option *ngFor="let city of (city$ | async)" [value]="city">
              <span>{{ city.city}} - {{city.state}}</span>
            </mat-option>
          </mat-autocomplete>

      </div>

        </mat-form-field>

      <mat-form-field style="width:80%">
      <div matRipple [matRippleDisabled]="true" #stateRipple style="display:flex;">

          <mat-label style="margin-right: 5px;">State:</mat-label>
          <input matInput formControlName = "state">
      </div>

        </mat-form-field>
        <!--
      <mat-form-field>
          <mat-label>Customer:</mat-label>
          <input matInput formControlName = "customer" [matAutocomplete] = "custauto">
        </mat-form-field>
  -->
        <mat-form-field style="width:80%">
      <div matRipple [matRippleDisabled]="true" #zipRipple style="display:flex;">
            <mat-label style="margin-right: 5px;">Zip:</mat-label>
            <input matInput formControlName = "zip">
        </div>

        </mat-form-field>


        <!--Electric Utility-->

      <!--
      <div matRipple [matRippleDisabled]="true" #elecRipple style="display:flex;">
        <p style="font-size: 20px; font-weight: 300">Electric Utility: {{elecUtility}}</p>
      </div>

      <div matRipple [matRippleDisabled]="true" #scopeRipple style="display:flex;">
        <p style="font-size: 20px; font-weight: 300">Subdivision Scope: {{defaultScope}}</p>
      </div>
      -->

      <!--
      <mat-form-field>
        <mat-label>Customer:</mat-label>
        <input matInput formControlName = "customer" [matAutocomplete] = "custauto">
      </mat-form-field>

      <mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectCustomer($event.option.value)" [displayWith]="displayFunction()">
        <mat-option *ngFor="let customer of (customer$ | async)" [value]="customer">
          <span>{{ customer.customer_name}}</span>
        </mat-option>
      </mat-autocomplete>
      -->


  </div>
</mat-tab>




<mat-tab label = "Details" >
  <div style="width:95%" style="height:550px; overflow-y:auto;">

    <br>

    <mat-form-field style="width:80%">
      <mat-label>Plan: {{planDisplay}}</mat-label>
      <input  #planname matInput formControlName = "plan_name" [matAutocomplete] = "plan">
      <button style="background: #424242;
      color: white;
      border-color: white;" (click)="clearPlan()">X</button>
      </mat-form-field>


  <mat-autocomplete #plan = "matAutocomplete" (optionSelected) = "onSelectPlan($event.option.value)" [displayWith]="displayFunctionPlan">
      <mat-option *ngFor="let plan of (plan$ | async)" [value]="plan">
        <span>{{ plan.plan_name}} ({{plan.customer_name}})</span>
      </mat-option>
    </mat-autocomplete>

    <br>

    <div class = "formitem-section" style="padding-right: 20px">
      <mat-label style="white-space: nowrap;"> Multifamily Plan Override? </mat-label>
      <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "mfplanoverride"></mat-checkbox>
    </div>

    <p style="padding-bottom: 1em;
      font-weight: bold;
      color: #424242;
      font-size: 12px;
      letter-spacing: 1px;">Registry Name: {{registrybuildertext}} </p>


    <mat-form-field style="width:55%; padding-right: 40px; margin-bottom: 2em;">
      <mat-label>BUID (Builder's Reference #)</mat-label>
      <input matInput formControlName = "buid">
    </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>Hvac Contractor:{{hvacDisplay}} </mat-label>
      <input  #contractorname matInput formControlName = "hvac_contractor_id" [matAutocomplete] = "hvacid">
      <button style="background: #424242;
      color: white;
      border-color: white;" (click)="clearContractor()">X</button>
      </mat-form-field>

  <mat-autocomplete #hvacid = "matAutocomplete" (optionSelected) = "onSelectContractor($event.option.value)" [displayWith]="displayFunctionHvac">
      <mat-option *ngFor="let contractor of (contractor$ | async)" [value]="contractor">
        <span>{{ contractor.customer_name}}</span>
      </mat-option>
    </mat-autocomplete>

    <br>

    <mat-form-field style="width:40%">
      <mat-label>Ekotrope ID: </mat-label>
      <input matInput #ekoInput formControlName = "ekotrope_id">
    </mat-form-field>
        <button *ngIf="ekoInput.value" mat-button [ngStyle]="{'color': hasRegistryId ? '#2e7d32' : '#c62828'}"
                [matTooltip]="hasRegistryId ? 'Registry ID present' : 'No Registry ID yet - re-import after you register in Ekotrope'"
                (click)="ekoImport(ekoInput.value)">Import <fa-icon [icon]="faImport"></fa-icon></button>
        <button *ngIf="ekoInput.value" mat-button color="primary" [disabled]="qaReviewLoading" (click)="qaReview()">{{ qaReviewLoading ? 'Checking...' : 'QA Review' }} <fa-icon [icon]="faQaReview"></fa-icon></button>
        <a *ngIf="ekoInput.value" [href]='getEkotropeLink(ekoInput.value)' target="_blank" style="color: black;">View Ekotrope Project</a>

        <div style="margin-top: 10px;">
          <button mat-button type="button" (click)="showQaReview = !showQaReview">{{ showQaReview ? 'Hide' : 'Show' }} QA Review Notes</button>
          <div *ngIf="showQaReview"
               style="white-space: pre-wrap; background:#ffffff; border:1px solid #d0d0d0; border-radius:4px; padding:0.75em; margin-top:0.5em; max-height:220px; overflow-y:auto; font-size:0.9em; color:#424242;">{{ qaReviewNote || 'No QA review has been run on this location yet.' }}</div>
        </div>

      <div fxLayout="row" fxLayout.xs = "column">
        <div matRipple [matRippleDisabled]="true" #regripple>
              <mat-form-field style="width:70%; margin-top: 20px;">
                <mat-label>Registry ID:</mat-label>
                <input matInput formControlName = "registryid">
              </mat-form-field>
              </div>

        <div matRipple [matRippleDisabled]="true" #ripple>
              <mat-form-field style="width:70%; margin-top: 20px;">
                  <mat-label>HERS index:</mat-label>
                  <input matInput formControlName = "hers_index">
                </mat-form-field>
              </div>

        </div>

        <mat-form-field style="width:25%; padding-right: 40px">
          <mat-label>Tax Parcel ID:</mat-label>
          <input matInput formControlName = "taxparcel">
        </mat-form-field>

    <mat-form-field style="width:80%">
      <mat-label>Contacts:</mat-label>
      <textarea matInput formControlName = "contacts"></textarea>
    </mat-form-field>

    <mat-form-field style="width:60%; padding-right: 40px">
      <mat-label>Premise #:</mat-label>
      <input matInput formControlName = "premiseno">
      <mat-checkbox  title = {{data.prmnochkdat}} style="padding-left: 5px; padding-right: 7px;" formControlName = "premnochkd"></mat-checkbox>
    </mat-form-field>

    <div fxLayout="row" fxLayout.xs = "column">

      <mat-form-field style="width:60%; padding-right: 40px">
        <mat-label>Permit #:</mat-label>
        <input matInput formControlName = "permit_no">
      </mat-form-field>

      <p>
        <mat-form-field>
          <mat-label>Permit Date {{ locationForm.get('permitdate').value }}</mat-label>
          <input matInput formControlName = 'permitdate'  [matDatepicker]="permitdate" disabled>
          <mat-datepicker-toggle matSuffix [for]="permitdate"></mat-datepicker-toggle>
          <mat-datepicker #permitdate disabled="false"></mat-datepicker>
        </mat-form-field>
      </p>


    </div>


       <mat-form-field style="width:60%">
          <mat-label>Google Drive Link:</mat-label>
          <input #driveInput matInput formControlName = "folderid">
        </mat-form-field>
        <a *ngIf="driveInput.value" [href]='getDriveLink(driveInput.value)' target="_blank" style="color: rgb(58, 76, 166);">Go to Folder</a>


      <mat-form-field style="width:80%">
        <mat-label>Weather Location:</mat-label>
        <input matInput formControlName = "weatherloc">
      </mat-form-field>


       <mat-form-field style="width:80%">
          <mat-label>County Form Link:</mat-label>
          <input matInput formControlName = "countyform">
        </mat-form-field>

        <div>

          
        <div style="width: 90%;
        margin: 1.5em;">
        <mat-form-field style="width:100%">
          <mat-label> Gas Utility </mat-label>
          <mat-select  formControlName = "gasutility" (selectionChange)="manualUpdateUtilities(2)">
            <mat-option *ngFor = "let utility of gasUtilities" [value] = "utility.company">
              {{utility.company}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        </div>

        <div style="width: 90%;
        margin: 1.5em;">
        <mat-form-field style="width:100%">
          <mat-label> Electric Utility </mat-label>
          <mat-select  formControlName = "elecutility" (selectionChange)="manualUpdateUtilities(1)">
            <mat-option *ngFor = "let utility of elecUtilities" [value] = "utility.company">
              {{utility.company}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        </div>

          <mat-form-field style="width:90%">
            <mat-label>Scope:</mat-label>
            <!--Show each item from this.scope-->
              <mat-select matNativeControl formControlName="scope" (selectionChange)="manualUpdateUtilities(3,$event.value)">
                <mat-option *ngFor="let scope of scopes" [value]="scope.scope">
                  {{scope.scope}}</mat-option>
                  <mat-option value="0">++ New Scope ++</mat-option>
                </mat-select>
          </mat-form-field>


        </div>

    <div *ngIf="locationForm.get('customer_id').value == 0">
      <p style="font-size: 1.25em;
        padding: 1em;
        color: #424242;">NOTE: For SWPPP, select a customer from the first tab.</p>
    </div>
    
    <div  *ngIf="locationForm.get('customer_id').value > 0" class = "formitem-section" style="padding-right: 20px;
    padding-top:1em;">
      <mat-label style="white-space: nowrap;">SWPPP?</mat-label>
      <mat-checkbox (change)="handleSWPPPclick($event.checked)" style="padding-left: 5px; padding-right: 7px;" formControlName = "swppp"></mat-checkbox>
    </div>

    <div id="swppp_info" style="padding-bottom: 1em;">
      <p>{{swpppCaption}}</p>
    </div>


    <div fxLayout="row" fxLayout.xs = "column">
        <p>
          <mat-form-field style="padding-right: 40px">
            <mat-label>Start Date {{ locationForm.get('startdate').value }}</mat-label>
            <input matInput formControlName = 'startdate' [matDatepicker]="startdate" disabled>
            <mat-datepicker-toggle matSuffix [for]="startdate"></mat-datepicker-toggle>
            <mat-datepicker #startdate disabled="false"></mat-datepicker>
          </mat-form-field>
        </p>

        <p>
          <mat-form-field>
            <mat-label>Close Date {{ locationForm.get('closedate').value }}</mat-label>
            <input matInput formControlName = 'closedate' [matDatepicker]="closedate" disabled>
            <mat-datepicker-toggle matSuffix [for]="closedate"></mat-datepicker-toggle>
            <mat-datepicker #closedate disabled="false"></mat-datepicker>
          </mat-form-field>
        </p>
        </div>

      <!-- <button style="margin-top:20px;" (click)="resetRem()" >Reset Linked File</button> -->
      <button style="margin-top:20px; margin-bottom: 20px; margin-left: 10px; " (click)="resetBuilderLocationButton()" >Reset Builder TEC</button>



      </div>



</mat-tab>


<mat-tab label = "Notes">
  <div style="width:95%" style="height:550px; overflow-y:auto;">
    <div style="display:flex; align-items:center; width:80%; padding-top:40px;">
      <mat-form-field style="flex:1;">
        <mat-label>Admin Notes: </mat-label>
        <textarea matInput formControlName = "adminnotes"></textarea>
      </mat-form-field>
      <button mat-stroked-button type="button" style="margin-left:8px; white-space:nowrap;" (click)="openAddAdminNote()">Add Signed Note</button>
    </div>

    <mat-form-field style="width:80%;padding-top:40px;">
      <mat-label>Site Notes: </mat-label>
      <textarea matInput formControlName = "site_notes"></textarea>
    </mat-form-field>

    <mat-form-field style="width:80%;padding-top:40px;">
      <mat-label>Billing Notes: </mat-label>
      <textarea matInput formControlName = "billing_notes"></textarea>
    </mat-form-field>


    <div *ngIf="locationForm.get('hvacnotes').value?.length > 0" style="width:80%;padding-top:40px;padding-bottom: 2em;">
      <mat-label>HVAC Notes </mat-label>
      <p>{{ locationForm.get('hvacnotes').value }}</p>
    </div>

    <div style="margin-top: 40px;">
    <mat-form-field>
      <mat-label> QA Type </mat-label>
      <mat-select  formControlName = "qatype">
        <mat-option value=""></mat-option>
        <mat-option value="File">File</mat-option>
        <mat-option value="Field">Field</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label> QAD </mat-label>
      <mat-select  formControlName = "qad">
          <mat-option value=""></mat-option>
          <mat-option value="Alex Earnest">Alex Earnest - 3096849</mat-option>
          <mat-option value="Beth Ainsworth">Beth Ainsworth - 7946824</mat-option>
          <mat-option value="Hunter Cook">Hunter Cook - 1598464</mat-option>
          <mat-option value="David Bess">David Bess - 3482251</mat-option>
          <mat-option value="Matthew Forster">Matthew Forster - 4380725</mat-option>
          <mat-option value="Sam Galphin">Sam Galphin - 1460588</mat-option>
          <mat-option value="Valeria Fabbiani">Valeria Fabbiani - 9630915</mat-option>
          <mat-option value="Zachary Sumner">Zachary Sumner - 4799282</mat-option>
      </mat-select>
    </mat-form-field>

    <p>
      <mat-form-field>
        <mat-label>QA Date</mat-label>
        <input matInput formControlName = 'qadate' [matDatepicker]="qadate" disabled>
        <mat-datepicker-toggle matSuffix [for]="qadate"></mat-datepicker-toggle>
        <mat-datepicker #qadate disabled="false"></mat-datepicker>
      </mat-form-field>
    </p>

    <mat-form-field style="width:80%;padding-top:40px;">
      <mat-label>QA Notes: </mat-label>
      <textarea matInput formControlName = "qanotes"></textarea>
    </mat-form-field>

    <div class = "formitem-section" style="padding-right: 20px">
      <mat-label>Reported?  </mat-label>
      <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "qareported"></mat-checkbox>
      </div>
    </div>

      <div style="margin-top: 40px;">
      <mat-form-field>
        <mat-label> QA Type </mat-label>
        <mat-select  formControlName = "qatype2">
          <mat-option value=""></mat-option>
          <mat-option value="File">File</mat-option>
          <mat-option value="Field">Field</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label> QAD  </mat-label>
        <mat-select  formControlName = "qad2">
          <mat-option value=""></mat-option>
          <mat-option value="Alex Earnest">Alex Earnest - 3096849</mat-option>
          <mat-option value="Beth Ainsworth">Beth Ainsworth - 7946824</mat-option>
          <mat-option value="Hunter Cook">Hunter Cook - 1598464</mat-option>
          <mat-option value="David Bess">David Bess - 3482251</mat-option>
          <mat-option value="Matthew Forster">Matthew Forster - 4380725</mat-option>
          <mat-option value="Sam Galphin">Sam Galphin - 1460588</mat-option>
          <mat-option value="Valeria Fabbiani">Valeria Fabbiani - 9630915</mat-option>
          <mat-option value="Zachary Sumner">Zachary Sumner - 4799282</mat-option>
        </mat-select>
      </mat-form-field>

      <p>
        <mat-form-field>
          <mat-label>QA Date</mat-label>
          <input matInput formControlName = 'qadate2' [matDatepicker]="qadate2" disabled>
          <mat-datepicker-toggle matSuffix [for]="qadate2"></mat-datepicker-toggle>
          <mat-datepicker #qadate2 disabled="false"></mat-datepicker>
        </mat-form-field>
      </p>

      <mat-form-field style="width:80%;padding-top:40px;">
        <mat-label>QA Notes: </mat-label>
        <textarea matInput formControlName = "qanotes2"></textarea>
      </mat-form-field>

      <div class = "formitem-section" style="padding-right: 20px">
        <mat-label>Reported?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "qareported2"></mat-checkbox>
        </div>

      </div>



  </div>
</mat-tab>

<mat-tab label = "Rebates">

  <div style="display:flex; flex-direction: column;">
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; padding: 2em; padding-bottom: 4em; border: 1px solid #ccc; max-width: 600px;" >
      <!-- Gas Box -->
      <div style="border: 1px solid #ddd; padding: 0.5em; border-radius: 8px; background-color: #f9f9f9;">
          <h3 style="margin: 0 0 10px;">Gas Rebate</h3>
          <!-- Add form controls here -->
          <mat-form-field style="margin-top: 15px;">
            <mat-label style=" white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;"> Rebate </mat-label>
            <mat-select class="my-special-select" formControlName = "gasrebate" (selectionChange)="updateRebateObj('gas','gasrebate',$event.value)">
              <mat-option *ngFor="let rebate of gasrebates" [value]="rebate.rebate">{{rebate.rebate}}</mat-option>
              <mat-option (onSelectionChange)="openGasRebateModal($event)">(Add New Option)</mat-option>
            </mat-select>
          </mat-form-field>

          <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
            <mat-label style=" white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Rebate 1  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "gas_rebate1" (change)="updateRebateObj('gas','gas_rebate1',$event.checked)"></mat-checkbox>
          </div>

          <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
            <mat-label style=" white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Rebate 2  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "gas_rebate2" (change)="updateRebateObj('gas','gas_rebate2',$event.checked)"></mat-checkbox>
          </div>

          <div>
            <mat-form-field style="margin-top: 15px;">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;"> Rebate 2 Status</mat-label>
              <mat-select  class="my-special-select" formControlName = "gas_rebate_2_status" (selectionChange)="updateRebateObj('gas','gas_rebate_2_status',$event.value)">
                <mat-option value = "Pass">Pass</mat-option>
                <mat-option value = "Fail">Fail</mat-option>
                <mat-option value = "Forgo">Forgo</mat-option>
                <mat-option value = "Not Eligible">Not Eligible</mat-option>
                <mat-option value = ""></mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- <input type="text" placeholder="Enter Gas Value" style="width: 100%; padding: 8px; margin-top: 5px; border: 1px solid #ccc; border-radius: 4px;"> -->
      </div>

      <!-- Electric Box -->
      <div style="border: 1px solid #ddd; padding: 0.5em; border-radius: 8px; background-color: #f9f9f9;">
          <h3 style="margin: 0 0 10px;">Electric Rebate</h3>
          <!-- Add form controls here -->
          <mat-form-field style="margin-top: 15px;">
            <mat-label style=" white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;"> Rebate </mat-label>
            <mat-select  class="my-special-select" formControlName = "elecrebate" (selectionChange)="updateRebateObj('electric','elecrebate',$event.value); selectionChangeRebate($event.value);">
              <mat-option *ngFor="let rebate of elecrebates" [value]="rebate.rebate">{{rebate.rebate}}</mat-option>
              <mat-option (onSelectionChange)="openElecRebateModal($event)">(Add New Option)</mat-option>
            </mat-select>
          </mat-form-field>

          <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
            <mat-label style=" white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Rebate 1  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "electric_rebate1" (change)="updateRebateObj('electric','electric_rebate1',$event.checked)"></mat-checkbox>
          </div>

          <div class = "formitem-section" style="padding: 0.25em;" style="padding-right: 20px">
            <mat-label style=" white-space: nowrap;
            font-size: 20px;
            color: #3f3f3f;
            letter-spacing: -0.5px;">Rebate 2  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "electric_rebate2" (change)="updateRebateObj('electric','electric_rebate2',$event.checked)"></mat-checkbox>
          </div>

          <div>
            <mat-form-field style="margin-top: 15px;">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;"> Rebate 2 Status</mat-label>
              <mat-select  class="my-special-select" formControlName = "electric_rebate_2_status" (selectionChange)="updateRebateObj('electric','electric_rebate_2_status',$event.value)">
                <mat-option value = "Pass">Pass</mat-option>
                <mat-option value = "Fail">Fail</mat-option>
                <mat-option value = "Forgo">Forgo</mat-option>
                <mat-option value = "Not Eligible">Not Eligible</mat-option>
                <mat-option value = ""></mat-option>

              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="tiers.length > 0">
            <mat-form-field style="margin-top: 15px;">
              <mat-label style=" white-space: nowrap;
              font-size: 20px;
              color: #3f3f3f;
              letter-spacing: -0.5px;">Tier</mat-label>
              <mat-select  formControlName = "electric_tier" (selectionChange)="updateRebateObj('electric','electric_tier',$event.value)">
                  <mat-option *ngFor="let tier of tiers" [value]="tier">{{tier}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>



      </div>
  </div>



  </div>


</mat-tab>

<mat-tab label = "Flags" >
  <div mat-dialog-content style="height:550px;width: 95%;overflow-y:auto;">

    <!-- Mirrors the Details-tab Ekotrope block; same controls, so the two stay in sync.
         Ref is #ekoInputFlags because a template ref name must be unique per template. -->
    <h3 style="color: #3f3f3f; font-size: 1.5em; padding-top: 0.5em;">Ekotrope</h3>

    <mat-form-field style="width:40%">
      <mat-label>Ekotrope ID: </mat-label>
      <input matInput #ekoInputFlags formControlName = "ekotrope_id">
    </mat-form-field>
        <button *ngIf="ekoInputFlags.value" mat-button [ngStyle]="{'color': hasRegistryId ? '#2e7d32' : '#c62828'}"
                [matTooltip]="hasRegistryId ? 'Registry ID present' : 'No Registry ID yet - re-import after you register in Ekotrope'"
                (click)="ekoImport(ekoInputFlags.value)">Import <fa-icon [icon]="faImport"></fa-icon></button>
        <button *ngIf="ekoInputFlags.value" mat-button color="primary" [disabled]="qaReviewLoading" (click)="qaReview()">{{ qaReviewLoading ? 'Checking...' : 'QA Review' }} <fa-icon [icon]="faQaReview"></fa-icon></button>
        <a *ngIf="ekoInputFlags.value" [href]='getEkotropeLink(ekoInputFlags.value)' target="_blank" style="color: black;">View Ekotrope Project</a>

        <div style="margin-top: 10px;">
          <button mat-button type="button" (click)="showQaReview = !showQaReview">{{ showQaReview ? 'Hide' : 'Show' }} QA Review Notes</button>
          <div *ngIf="showQaReview"
               style="white-space: pre-wrap; background:#ffffff; border:1px solid #d0d0d0; border-radius:4px; padding:0.75em; margin-top:0.5em; max-height:220px; overflow-y:auto; font-size:0.9em; color:#424242;">{{ qaReviewNote || 'No QA review has been run on this location yet.' }}</div>
        </div>

      <div fxLayout="row" fxLayout.xs = "column">
        <mat-form-field style="width:70%; margin-top: 20px;">
          <mat-label>Registry ID:</mat-label>
          <input matInput formControlName = "registryid">
        </mat-form-field>

        <mat-form-field style="width:70%; margin-top: 20px;">
          <mat-label>HERS index:</mat-label>
          <input matInput formControlName = "hers_index">
        </mat-form-field>
      </div>

    <hr style="margin: 1em 0; border: 0; border-top: 1px solid #e0e0e0;">

    <h3>Check the items below that apply</h3>
    <br>
    <div style="display: flex; flex-direction:row; flex-wrap: wrap">

      <div class = "formitem-section" style="padding-right: 20px">
        <mat-label style="white-space: nowrap;">Disclosure Sent?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "disclosuresent"></mat-checkbox>
      </div>

      <div class = "formitem-section" style="padding-right: 20px">
          <mat-label style="white-space: nowrap;">County Form Sent?  </mat-label>
          <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "cfsent"></mat-checkbox>
        </div>

      <div class = "formitem-section" style="padding-right: 20px">
        <mat-label style="white-space: nowrap;">Cert Printed?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "cert_printed" (change)="certPrintedDateUpdate()"></mat-checkbox>
      </div>

      <div class = "formitem-section" style="padding-right: 20px">
        <mat-label style="white-space: nowrap;">ESMFNC Data Needed?</mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "esmfnc"></mat-checkbox>
      </div>


      <div class = "formitem-section" style="padding-right: 20px">
        <mat-label style="white-space: nowrap;">REM File Done?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "rem_done"></mat-checkbox>
        </div>
    </div>

    <div style="display: flex; flex-direction:row; flex-wrap: wrap">


    <div class = "formitem-section" style="padding-right: 20px">
      <mat-label style="white-space: nowrap;">Tax Credit?  </mat-label>
      <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "taxcred"></mat-checkbox>
    </div>

    <div class = "formitem-section" style="padding-right: 20px">
      <mat-label style="white-space: nowrap;">Archive This?  </mat-label>
      <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "adminarchive"></mat-checkbox>
      </div>

    <div class = "formitem-section" style="padding-right: 20px">
          <mat-label style="white-space: nowrap;">Hvac Paperwork Override?  </mat-label>
          <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "hvacovrd"></mat-checkbox>
          </div>

    <div class = "formitem-section" style="padding-right: 20px">
        <mat-label style="white-space: nowrap;">Missing Info?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "missinginfo" (change)="missingInfoUpdate()"></mat-checkbox>
        </div>

    <div class = "formitem-section" style="padding-right: 20px">
        <mat-label style="white-space: nowrap;">Targets Set?</mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "targetset"></mat-checkbox>
        </div>

    </div>

    <div style="display: flex; flex-direction:row; flex-wrap: wrap">

        <div class = "formitem-section" style="padding-right: 20px">
            <mat-label>Final Notice?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "finalnotice"></mat-checkbox>
            </div>

        <div class = "formitem-section" style="padding-right: 20px">
            <mat-label>Final Report?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "finalreport"></mat-checkbox>
            </div>

        <div class = "formitem-section" style="padding-right: 20px">
            <mat-label>Rough Notice?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "roughnotice"></mat-checkbox>
            </div>

        <div class = "formitem-section" style="padding-right: 20px">
            <mat-label>Rough Report?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "roughreport"></mat-checkbox>
            </div>

    </div>


<!--
    <div>
      <div class = "formitem-section" style="padding-right: 20px" title="Hero Initial Registration">
            <mat-label>Rebate 1?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "rebate1"></mat-checkbox>
        </div>
    </div>

        <div>
      <div class = "formitem-section" style="padding-right: 20px" title="Hero Final Submission">
            <mat-label>Rebate 2?  </mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "rebate2"></mat-checkbox>
          </div>

          <mat-form-field style="width:70%; margin-top: 15px; ">
            <mat-label> Rebate 2 Status </mat-label>
            <mat-select  formControlName = "rebate2stat">

              <mat-option value = "Pass HERO">Pass HERO</mat-option>
              <mat-option value = "Failed HERO/Canceled">Failed HERO/Canceled</mat-option>
              <mat-option value = "Forgo HERO/Canceled">Forgo HERO/Canceled</mat-option>
              <mat-option value = "Not in HERO territory/Canceled">Not in HERO territory/Canceled</mat-option>
              <mat-option value = ""> </mat-option>

            </mat-select>
          </mat-form-field>
      </div>

-->


    <div>
      <div class = "formitem-section" style="padding-right: 20px" title="Gas Rebate">
        <mat-label>Rebate 3?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" (change)="updateRebate3()" formControlName = "rebate3"></mat-checkbox>
      </div>

      <div class = "formitem-section" style="padding-right: 20px">
            <mat-label>HVAC-DR Request</mat-label>
            <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "hvac_dr_request"></mat-checkbox>
            </div>
    </div>

      <div>
        <h3 style="color: #3f3f3f;font-size: 1.5em;">HVAC Grading</h3>

          <div style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center;">
            <div style="padding-right: 2em;">
              <mat-form-field style="margin-top: 15px;">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;"> 310 Report</mat-label>
                <mat-select  formControlName = "threetenrep">
                  <mat-option value = "Requested">Requested</mat-option>
                  <mat-option value = "Received">Received</mat-option>
                  <mat-option value = "Approved">Approved</mat-option>
                  <mat-option value = "Rejected">Rejected</mat-option>
                  <mat-option value = ""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div>
              <mat-form-field style="margin-top: 15px;">
                <mat-label style=" white-space: nowrap;
                font-size: 20px;
                color: #3f3f3f;
                letter-spacing: -0.5px;"> Refrigerant PW</mat-label>
                <mat-select  formControlName = "refrigpw">
                  <mat-option value = "Requested">Requested</mat-option>
                  <mat-option value = "Received">Received</mat-option>
                  <mat-option value = "Approved">Approved</mat-option>
                  <mat-option value = "Rejected">Rejected</mat-option>
                  <mat-option value = "Ineligible">Ineligible</mat-option>
                  <mat-option value = ""></mat-option>
                </mat-select>
              </mat-form-field>
            </div>
        </div>

      </div>



    </div>

</mat-tab>

<mat-tab label = "Audit" >

  <div mat-dialog-content style="height:550px;width: 95%;overflow-y:auto;">

    <div>

      <div style="margin-top: 30px; margin-bottom: 30px;">
      <mat-form-field>
        <mat-label >Auditor Name</mat-label>
        <mat-select formControlName = 'auditorname'>
          <mat-option value="Hunter Cook">Hunter Cook</mat-option>
          <mat-option value="Jacob Buckner">Jacob Buckner</mat-option>
          <mat-option value="Zach Sumner">Zach Sumner</mat-option>
          <mat-option value="David Bess">David Bess</mat-option>
        </mat-select>
      </mat-form-field>
      </div>


      <div matRipple [matRippleDisabled]="true" #regionRipple>
        <mat-form-field>
          <mat-label> Region </mat-label>
          <mat-select  formControlName = "region">
            <mat-option *ngFor = "let region of regions" [value] = "region.value">
              {{region.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        </div>


      <div style="margin-bottom: 30px;">
        <mat-label style="margin-right:35px;">Construction Stage</mat-label>
        <mat-radio-group formControlName = 'constage'>
          <mat-radio-button style="margin-right:15px;" value="File">File</mat-radio-button>
          <mat-radio-button style="margin-right:15px;" value="Rough">Rough</mat-radio-button>
          <mat-radio-button style="margin-right:15px;" value="Final">Final</mat-radio-button>
        </mat-radio-group>
      </div>

      <div style="margin-bottom: 30px;">
        <mat-label style="margin-right:35px;">Type</mat-label>
        <mat-radio-group formControlName = 'audtype'>
          <mat-radio-button style="margin-right:15px;" value="Blind">Blind</mat-radio-button>
          <mat-radio-button style="margin-right:15px;" value="Ride along">Ride along</mat-radio-button>
        </mat-radio-group>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Audit Notes</mat-label>
          <textarea columns="30" rows="10" matInput formControlName = 'audnotes'></textarea>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Overall Score</mat-label>
          <input matInput formControlName = 'ovlscore' type="number" min="0" max="999">
        </mat-form-field>
      </div>

      <p>
        <mat-form-field>
          <mat-label>Inspection Date</mat-label>
          <input matInput formControlName = 'audinspdate' [matDatepicker]="audinspdate" disabled>
          <mat-datepicker-toggle matSuffix [for]="audinspdate"></mat-datepicker-toggle>
          <mat-datepicker #audinspdate disabled="false"></mat-datepicker>
        </mat-form-field>
      </p>

      <div>
        <button (click)="sendAuditEmail()">Send Email</button>
      </div>

      <div class = "formitem-section" style="padding-right:20px">
        <mat-label style="white-space: nowrap;">Audit Reported?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "audreported"></mat-checkbox>
      </div>


    </div>
  </div>

</mat-tab>

<mat-tab label = "Tags">

        <!-- The chip input control -->
        <div style="display: flex;
        width: 90%;
        min-height: 200px;
        margin-top: 30px;
        align-content: flex-start;
        flex-wrap: wrap;
        justify-content: space-evenly;">
        <mat-form-field style="width:85%;">
          <mat-chip-list #chipList>
            <mat-chip *ngFor="let tag of inputTags" [selectable]="true" [removable]="true" (removed)="removeTag(tag)">
              {{tag.displayname}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input placeholder="Add tag..."
                   [matAutocomplete]="auto"
                   [matChipInputFor]="chipList"
                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                   (matChipInputTokenEnd)="addTag($event)"
                   (keyup.enter)="onEnter(auto)"
                   formControlName="tagControl">
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTag($event, $event.option.value)">
            <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
              {{tag.displayname}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <!-- Tags on this location's subdivision. Display only. -->
        <div *ngIf="subdivisionTags.length > 0" style="width:85%; margin-bottom:1em;">
          <p style="color: #75BD4E; margin: 0 0 0.25em 0; font-size: 0.9em;">Inherited from subdivision{{ theSubdivision ? ' (' + theSubdivision.toString().trim() + ')' : '' }}:</p>
          <mat-chip-list [selectable]="false">
            <mat-chip *ngFor="let tag of subdivisionTags" [disableRipple]="true" matTooltip="{{tag.description}}">{{tag.displayname}}</mat-chip>
          </mat-chip-list>
        </div>
      </div>

        <!-- MF / SF / GPS tag-type filter. None ticked = show all. -->
        <div style="display:flex; gap:1em; margin-bottom:0.5em; align-items:center;">
          <span style="color:#757575; font-size:0.9em;">Show:</span>
          <mat-checkbox *ngFor="let t of tagService.TAG_TYPES"
                        [checked]="tagTypeFilter.includes(t)"
                        (change)="toggleTagType(t)">{{t}}</mat-checkbox>
        </div>

        <div style="height: 200px;">
        <mat-chip-list>
          <mat-chip *ngFor="let tag of visibleTags" (click)="addTag($event, tag)" matTooltip="{{tag.description}}">{{tag.displayname}}</mat-chip>
        </mat-chip-list>

      </div>

</mat-tab>

</mat-tab-group>

  <div class ="form-actions-sticky-div" style="display: flex; justify-content: space-around;padding-top:0.25em;padding-bottom: 0.25em;">
    <div matRipple [matRippleDisabled]="true" #elecRipple style="display:flex;">
      <p style="font-size: 0.9em; font-weight: 300">Electric Utility: <span style="font-size: 0.9em;font-weight: 500;color: #424242;">
        {{elecUtility? elecUtility : locationForm.get('elecutility').value }}</span></p>
    </div>
    <div matRipple [matRippleDisabled]="true" #elecRipple style="display:flex;">
      <p style="font-size: 0.9em; font-weight: 300">Gas Utility: <span style="font-size: 0.9em;font-weight: 500;color: #424242;">
        {{gasUtility ? gasUtility : locationForm.get('gasutility').value }}</span></p>
    </div>
    <div matRipple [matRippleDisabled]="true" #scopeRipple style="display:flex;">
      <p style="font-size: 0.9em; font-weight: 300">Subdivision Scope: <span style="font-size: 0.9em;font-weight: 500;color: #424242;">
        {{defaultScope}}</span> </p>
    </div>
  </div>

  <!--Tags-->
  <div style="display:flex;flex-wrap: wrap;padding-left: 4em;">
      <p style="font-size: 0.85em;color: #424242; font-weight: 600;">Tags:</p>
      <p *ngFor="let tag of inputTags" style="white-space: normal;padding-left:0.25em;font-size: 0.85em;color: #424242;font-weight: 600;">
        [{{tag.displayname}}]</p>
  </div>

  <div>
    <button mat-button (click)="onNoClick()">Close</button>
    <span *ngIf ="mode == EDITING_MODE" [matTooltip]="'Select a subdivision from the dropdown first'" [matTooltipDisabled]="subdivisionIsValid">
      <button mat-button [disabled]="!subdivisionIsValid" (click)="save()" cdkFocusInitial>Save</button>
    </span>
    <span *ngIf="mode == ADDING_MODE" [matTooltip]="'Select a subdivision from the dropdown first'" [matTooltipDisabled]="subdivisionIsValid">
      <button mat-button [disabled]="!subdivisionIsValid" (click)="add()" cdkFocusInitial>Add</button>
    </span>

  <div *ngIf="isDuplicate" style="color: red; margin-top: 8px;">
    {{ duplicateWarning }}
  </div>
  </div>
</form>
